import { Link } from 'react-router-dom';

function ClientServices (props){



    return(
        <div className={props.isMobile ? 'toolbar-item' :"toolbar-item hidden-on-mobile"}>
          <Link to="" className="no-href-deco">
            <div>
              <span className="compare-icon">
                <i className="icon-help-circle" />
              </span>
              <span className="text-label">Ayuda</span>
            </div>
          </Link>
          <div className="toolbar-dropdown text-center px-3">
            <Link to="/Contacto" className="no-href-deco">
              <div className="row px-3">
                <p className="mt-2 mb-2  no-href-deco">
                  <i className="icon-mail mr-2"></i>Contacto
                </p>
              </div>
            </Link>
            <Link to="/Envios" className="no-href-deco">
              <div className="row px-3">
                <p className="mt-2 mb-2  no-href-deco">
                  <i className="icon-truck mr-2"></i>Envios
                </p>
              </div>
            </Link>
            <Link to="/FormasDePago" className="no-href-deco">
              <div className="row px-3">
                <p className="mt-2 mb-2  no-href-deco">
                  <i className="icon-credit-card mr-2"></i>Formas de pago
                </p>
              </div>
            </Link>
            <Link to="/PoliticasCia" className="no-href-deco">
              <div className="row px-3">
                <p className="mt-2 mb-2  no-href-deco">
                  <i className="icon-info mr-2"></i>Políticas de la cia.
                </p>
              </div>
            </Link>
            <Link to="/Faqs" className="no-href-deco">
              <div className="row px-3">
                <p className="mt-2 mb-2 no-href-deco">
                  <i className="icon-help-circle mr-2"></i>Preg. frecuentes
                </p>
              </div>
            </Link>
            {/* <Link to="/ServiciosAlCliente" className="no-href-deco">
              <div className="row px-3">
                <p className="mt-2 mb-2">
                  <i className="icon-shopping-bag mr-2"></i>
                  Servicios al cliente
                </p>
              </div>
            </Link> */}
          </div>
        </div>
    )
}

export default ClientServices;